// European sites with GDPR policy handling
export const EU_SITE_COOKIE_NAME = 'eu-site';
// Protection of selling personal information under California or Nevada law
export const CCPA_STATE_COOKIE_NAME = 'dnsmpi';
// Custom event to call when page query change ( page refresh )
export const ADS_REFRESH_EVENT = 'DisplayAdRefresh';
// GDPR compliance
export const GDPR_COOKIE_NAME = 'ha-cookie-settings';

export const MESO_AD_EVENTS = {
    PASS: 'AD-LOAD-PASS',
    FAIL: 'AD-LOAD-FAIL',
    EMPTY: 'AD-LOAD-EMPTY',
};

export const MESO_SLOT_STATUSES = {
    LOADING: 'loading',
    FAILED: 'failed',
    LOADED: 'loaded',
    RENDERING_FAILURE: 'RENDERING-FAILURE'
};
